import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { defaultRuleset } from 'query-builder/core/simple-query-default-ruleset';
import { GetDefaultEntityTypeService } from 'core/get-default-entity-type.service';
import { Rule, RuleSet } from 'query-builder/query.interfaces';
import { of } from 'rxjs';
import { GetDefaultSavedQueryGQL } from 'generated/graphql';

/**
 * Handles configuration of the query builder module.
 * Type indicates which component type will be rendered
 *
 */
@Injectable({
  providedIn: 'root'
})
export class DefaultRulesetService {
  constructor(
    private getDefaultEntityType: GetDefaultEntityTypeService,
    private getSavedDefaultQueryGQL: GetDefaultSavedQueryGQL
  ) {
  }

  getDefaultEntityTypeScopedRuleset(campaignId: string) {
    return this.getDefaultEntityType.getDefaultEntityType(campaignId).pipe(
      map(de => defaultRuleset(de?.id))
    );
  }

  getCampaignDefaultSavedQuery(campaignId: string) {
    return this.getSavedDefaultQueryGQL.fetch({ campaignId }).pipe(
      map(res => res.data.getDefaultSavedQuery)
    );
  }

  getCampaignDefaultRuleSet(campaignId: string) {
    return this.getCampaignDefaultSavedQuery(campaignId).pipe(
      switchMap(query => of(query))
    );
  }

  getFollowUpRuleset() {
    const followUpRuleSet = defaultRuleset() as RuleSet;
    const followUpRule = followUpRuleSet.rules.find((rule: Rule) => rule.field === 'follow_up_by') as Rule;
    followUpRule.value = 'assigned_user';
    followUpRule.operator = 'include';

    return of(followUpRuleSet);
  }

  getFlaggedEntitiesRuleset() {
    const flaggedEntitiesRuleSet = defaultRuleset() as RuleSet;
    const flaggedEntitiesRule = flaggedEntitiesRuleSet.rules.find((rule: Rule) => rule.field === 'follow_up_by') as Rule;
    flaggedEntitiesRule.value = 'any_user';
    flaggedEntitiesRule.operator = '=';

    return of(flaggedEntitiesRuleSet);
  }

  getFlaggedByYouRuleset() {
    const flaggedByYouRuleSet = defaultRuleset() as RuleSet;
    const flaggedByYouRule = flaggedByYouRuleSet.rules.find((rule: Rule) => rule.field === 'follow_up_by') as Rule;
    flaggedByYouRule.value = 'current_user';
    flaggedByYouRule.operator = '=';

    return of(flaggedByYouRuleSet);
  }
}
